import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, vModelSelect as _vModelSelect, normalizeStyle as _normalizeStyle, vModelCheckbox as _vModelCheckbox } from "vue"
import _imports_0 from '@/assets/sounds/Camera-Film03-1.mp3'


const _hoisted_1 = {
  key: 0,
  class: "overlay"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "処理中...", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  hidden: "true",
  ref: "cameraSound"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("source", {
  src: _imports_0,
  type: "audio/mpeg"
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  ref: "videoMainCamera",
  width: "0",
  height: "0",
  style: {"position":"absolute","width":"100%","z-index":"99","left":"0"},
  autoplay: ""
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { style: {"position":"absolute","width":"100%","left":"0"} }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"60px"} }, null, -1)
const _hoisted_12 = {
  class: "col-3",
  style: {"top":"46px","font-size":"11px","height":"100vh","display":"inline-block","left":"0","position":"absolute","text-align":"center"}
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h6", null, "直近の結果", -1)
const _hoisted_14 = { class: "col-6 float-start" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { style: {"display":"inline-block"} }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, " 削孔長"),
  /*#__PURE__*/_createElementVNode("th", null, " 削孔径 ")
], -1)
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "col-6 float-end" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = { style: {"display":"inline-block"} }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, " 削孔長"),
    /*#__PURE__*/_createElementVNode("th", null, " 削孔径 ")
  ])
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = { style: {"z-index":"4","height":"300px","width":"250px","text-align":"center","left":"0px","position":"fixed","bottom":"17%"} }
const _hoisted_25 = { class: "col-12" }
const _hoisted_26 = { class: "col-4 float-start" }
const _hoisted_27 = { class: "col-4 float-start" }
const _hoisted_28 = { class: "col-4 float-end" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_31 = { class: "col-12" }
const _hoisted_32 = { class: "col-4 float-start" }
const _hoisted_33 = { class: "col-4 float-start" }
const _hoisted_34 = { class: "col-4 float-end" }
const _hoisted_35 = { style: {"width":"100%","margin-top":"80px","position":"absolute","left":"0"} }
const _hoisted_36 = ["width", "height"]
const _hoisted_37 = ["width", "height"]
const _hoisted_38 = ["width", "height"]
const _hoisted_39 = ["width", "height"]
const _hoisted_40 = ["width", "height"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { style: {"z-index":"1","position":"absolute","left":"0","right":"0","margin":"auto","background":"gray","width":"320px","height":"320px"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"white","text-align":"center","font-size":"14px","line-height":"100%","display":"inline-block","margin-top":"30%","position":"absolute","width":"100%","height":"100%","left":"0"} }, " リアカメラを選択して下さい ")
], -1)
const _hoisted_42 = { style: {"position":"absolute","bottom":"-98px","left":"39%","transform":"translateX(-52%)","z-index":"99","display":"flex","align-items":"center","gap":"5px"} }
const _hoisted_43 = { style: {"display":"flex","flex-direction":"column","align-items":"center","gap":"2px"} }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"3px"} }, null, -1)
const _hoisted_45 = { style: {"display":"flex","flex-direction":"column","align-items":"center","gap":"2px"} }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("b", null, "+", -1)
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("b", null, "-", -1)
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"3px"} }, null, -1)
const _hoisted_51 = { style: {"display":"flex","gap":"10px"} }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("b", null, "⟳", -1)
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"3px"} }, null, -1)
const _hoisted_55 = { style: {"display":"flex","flex-direction":"column","align-items":"center","gap":"2px"} }
const _hoisted_56 = ["disabled"]
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"3px"} }, null, -1)
const _hoisted_58 = { style: {"display":"flex","flex-direction":"column","align-items":"center","gap":"2px"} }
const _hoisted_59 = ["value"]
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { style: {"position":"absolute","bottom":"0","left":"50%","transform":"translateX(-50%)"} }, [
  /*#__PURE__*/_createElementVNode("button", { class: "btn btn-dark" }, "Button 1"),
  /*#__PURE__*/_createElementVNode("button", { class: "btn btn-dark" }, "Button 2")
], -1)
const _hoisted_61 = { style: {"bottom":"-15%","right":"0","border":"white 1px solid","min-width":"120px","min-height":"70px","width":"25%","height":"25%","position":"absolute","background":"gray"} }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"white","text-align":"center","font-size":"10px","line-height":"100%","display":"inline-block","margin-top":"30%","position":"absolute","width":"100%","height":"100%","left":"0"} }, " 外部カメラを選択してください。 ", -1)
const _hoisted_63 = {
  ref: "videoSubCamera",
  style: {"position":"absolute","width":"100%","z-index":"99","left":"0"},
  autoplay: ""
}
const _hoisted_64 = ["value"]
const _hoisted_65 = ["width", "height"]
const _hoisted_66 = {
  ref: "touchFeedback",
  style: {"position":"absolute","top":"10px","left":"10px","background-color":"yellow","padding":"5px","display":"none"}
}
const _hoisted_67 = {
  class: "col-12",
  style: {"position":"absolute","left":"0","display":"inline-block"}
}
const _hoisted_68 = {
  style: {"text-align":"left"},
  class: "col-9 offset-3"
}
const _hoisted_69 = /*#__PURE__*/_createElementVNode("b", null, "削孔長 : ", -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("b", null, " 削孔径 : ", -1)
const _hoisted_71 = { key: 0 }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("b", null, " 原寸大スケールのサイズ : ", -1)
const _hoisted_73 = {
  class: "col-9 offset-3",
  style: {"text-align":"left","display":"flex","align-items":"center","gap":"10px"}
}
const _hoisted_74 = {
  key: 0,
  class: "row col-12",
  style: {"z-index":"999999","position":"fixed","bottom":"0","left":"0","width":"100%","text-align":"center","background-color":"rgba(120,120,120,0.8)","color":"white","font-weight":"bold"}
}
const _hoisted_75 = /*#__PURE__*/_createElementVNode("b", { class: "col-12" }, "デバッグ", -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_77 = {
  style: {"text-align":"left"},
  class: "col-6"
}
const _hoisted_78 = /*#__PURE__*/_createElementVNode("label", null, "削孔検出感度 :", -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_80 = {
  key: 0,
  style: {"padding":"2%"},
  id: "test-circle-setting"
}
const _hoisted_81 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  style: {"color":"blue !important"},
  href: "http://opencv.jp/opencv-2svn/cpp/feature_detection.html#cv-houghcircles"
}, "HoughCircles パラメータ説明 http://opencv.jp/opencv-2svn/cpp/feature_detection.html#cv-houghcircles ", -1)
const _hoisted_82 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_83 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_84 = { class: "col-6" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_88 = /*#__PURE__*/_createElementVNode("span", null, "error", -1)
const _hoisted_89 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_90 = { style: {"bottom":"10%","position":"absolute","width":"100%","left":"0"} }
const _hoisted_91 = { style: {"width":"66%","z-index":"9999","padding":"2px","position":"absolute","left":"16.3%"} }
const _hoisted_92 = { class: "show-excel col-3 offset-1" }
const _hoisted_93 = { class: "show-excel col-3 offset-1" }
const _hoisted_94 = {
  key: 0,
  class: "show-excel",
  style: {"width":"100%","padding":"8px","background":"rgb(245,246,247)"}
}
const _hoisted_95 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_96 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_97 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_98 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_99 = { class: "show-excel input-group input-group-sm mb-3" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("span", {
  class: "show-excel input-group-text",
  id: "inputGroupFileAddon01"
}, "エクセルファイルのインポート ", -1)
const _hoisted_101 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_102 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_103 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_104 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_105 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_106 = /*#__PURE__*/_createElementVNode("div", { style: {"z-index":"999, margin:0 auto","position":"absolute","left":"0%"} }, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "spreadsheet-area",
    class: "flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
  }, [
    /*#__PURE__*/_createElementVNode("div", { id: "x-spreadsheet" })
  ])
], -1)
const _hoisted_107 = { key: 1 }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("div", { class: "col-10 offset-1 text-start" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "h5" }, "削孔長 ")
], -1)
const _hoisted_109 = /*#__PURE__*/_createElementVNode("div", { class: "col-10 offset-1 text-start" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "h5" }, "位置の調整 ")
], -1)
const _hoisted_110 = /*#__PURE__*/_createElementVNode("div", { class: "col-10 offset-1 text-start" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "h5" }, "位置の調整 ")
], -1)
const _hoisted_111 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_112 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_113 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_114 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_115 = /*#__PURE__*/_createElementVNode("h3", null, "操作性", -1)
const _hoisted_116 = /*#__PURE__*/_createElementVNode("b", null, "カメラのFPS設定", -1)
const _hoisted_117 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_118 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_119 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_120 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_121 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_122 = /*#__PURE__*/_createElementVNode("b", null, "円の検出の周期(ミリ秒)", -1)
const _hoisted_123 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_124 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_125 = /*#__PURE__*/_createElementVNode("b", null, "レーザの周期(ミリ秒) ", -1)
const _hoisted_126 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_127 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_128 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_129 = /*#__PURE__*/_createElementVNode("h2", null, " レーザの補正 ", -1)
const _hoisted_130 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_131 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_132 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_133 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_134 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_135 = /*#__PURE__*/_createElementVNode("b", null, "レーザのツラから棒の先迄の長さ(m)", -1)
const _hoisted_136 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_137 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_138 = /*#__PURE__*/_createElementVNode("b", null, "レーザのツラからステイのツラ迄の長さ(m)", -1)
const _hoisted_139 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_140 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_141 = /*#__PURE__*/_createElementVNode("b", null, "カメラのツラからレーザのツラまでの長さ (mm)", -1)
const _hoisted_142 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_143 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_144 = /*#__PURE__*/_createElementVNode("b", null, "近距離での計測 ", -1)
const _hoisted_145 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_146 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_147 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_148 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_149 = /*#__PURE__*/_createElementVNode("h3", null, "実際の値", -1)
const _hoisted_150 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_151 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_152 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_153 = { key: 0 }
const _hoisted_154 = /*#__PURE__*/_createElementVNode("h3", null, "現在の補正値", -1)
const _hoisted_155 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_156 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_157 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_158 = { key: 1 }
const _hoisted_159 = /*#__PURE__*/_createElementVNode("h3", null, "差", -1)
const _hoisted_160 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_161 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_162 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_163 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_164 = /*#__PURE__*/_createElementVNode("label", null, "7cm以下のセンサを除外する", -1)
const _hoisted_165 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_166 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_h7 = _resolveComponent("h7")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_SerialConnection = _resolveComponent("SerialConnection")!

  return (_openBlock(), _createElementBlock("div", null, [
    ($data.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("audio", _hoisted_4, _hoisted_6, 512),
    _createElementVNode("video", _hoisted_7, null, 512),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("button", {
        class: "btn btn-dark ms-1 col-2",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.showArea('Excel')))
      }, " エクセル "),
      _createElementVNode("button", {
        class: "btn btn-dark ms-1 col-2",
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.showArea('Canvas')))
      }, " 計測 "),
      _createElementVNode("button", {
        class: "btn btn-dark ms-1 col-2",
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.showArea('Setting')))
      }, " 設定 "),
      _hoisted_10
    ]),
    _hoisted_11,
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_h7, null, {
            default: _withCtx(() => [
              _createTextVNode(" 1~10 ")
            ]),
            _: 1
          }),
          _hoisted_15,
          _createElementVNode("table", _hoisted_16, [
            _createElementVNode("thead", null, [
              _hoisted_17,
              ($data.nonOverlapCircleAreaEnabled)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                    _createElementVNode("span", null, " 非重複領域: " + _toDisplayString($options.ceilDemicalPoint(this.nonOverlapCircleArea * 0.01, 1)) + " cm²", 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.recentlyAcquiredData.slice(0,10), (data) => {
                return (_openBlock(), _createElementBlock("tr", { key: data }, [
                  _createElementVNode("td", null, _toDisplayString($options.exchangeToColName( data.fullLength.col+1 )) + _toDisplayString(data.fullLength.row) + ": " + _toDisplayString($options.ceilDemicalPoint(data.fullLength.data ,3)), 1),
                  _createElementVNode("td", null, _toDisplayString($options.exchangeToColName( data.diameter.col+1 )) + _toDisplayString(data.diameter.row) + ": " + _toDisplayString($options.ceilDemicalPoint(data.diameter.data,1)), 1)
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_h7, null, {
            default: _withCtx(() => [
              _createTextVNode(" 11~20 ")
            ]),
            _: 1
          }),
          _createTextVNode(),
          _hoisted_20,
          _createElementVNode("table", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.recentlyAcquiredData.slice(10,20), (data) => {
                return (_openBlock(), _createElementBlock("tr", { key: data }, [
                  _createElementVNode("td", null, _toDisplayString($options.exchangeToColName( data.fullLength.col+1 )) + _toDisplayString(data.fullLength.row) + ": " + _toDisplayString($options.ceilDemicalPoint(data.fullLength.data,3)), 1),
                  _createElementVNode("td", null, _toDisplayString($options.exchangeToColName( data.diameter.col+1 )) + _toDisplayString(data.diameter.row) + ": " + _toDisplayString($options.ceilDemicalPoint(data.diameter.data,1)), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _hoisted_23,
      _withDirectives(_createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("button", {
              id: "CircleDetectionSettingBtn1",
              class: _normalizeClass([{ "btn-dark ":$data.selectedCircleDetectionMode!==1,"btn-success":$data.selectedCircleDetectionMode===1 }, "btn btn-sm"]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($options.selectDetectedCircle(1)))
            }, " 小 ", 2)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("button", {
              id: "CircleDetectionSettingBtn2",
              class: _normalizeClass([{ "btn-dark ":$data.selectedCircleDetectionMode!==2,"btn-success":$data.selectedCircleDetectionMode===2 }, "btn btn-sm"]),
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($options.selectDetectedCircle(2)))
            }, " 中 ", 2)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("button", {
              id: "CircleDetectionSettingBtn3",
              class: _normalizeClass([{ "btn-dark":$data.selectedCircleDetectionMode!==3,"btn-success":$data.selectedCircleDetectionMode===3 }, "btn btn-sm"]),
              onClick: _cache[5] || (_cache[5] = ($event: any) => ($options.selectDetectedCircle(3)))
            }, " 大 ", 2)
          ]),
          _hoisted_29
        ]),
        _hoisted_30,
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("button", {
              class: _normalizeClass(["btn btn-sm", {  "btn-dark": (!$data.selectCircleMode) , "btn-success": $data.selectCircleMode }]),
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($options.selectCircle && $options.selectCircle(...args)))
            }, "選択", 2)
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("button", {
              class: _normalizeClass(["btn btn-sm", {  "btn-secondary": (!$data.selectCircleMode) , "btn-dark": $data.selectCircleMode }]),
              onClick: _cache[7] || (_cache[7] = ($event: any) => ($data.selectCircleMode=false))
            }, "解除", 2)
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("button", {
              class: "btn btn-sm btn-dark",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ($options.removeDetectedCircle && $options.removeDetectedCircle(...args)))
            }, "削除")
          ])
        ])
      ], 512), [
        [_vShow, $data.isMeasuring]
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", null, [
          _createElementVNode("canvas", {
            style: {"z-index":"3","background":"white","position":"absolute","left":"0","right":"0","margin":"auto"},
            ref: "canvas",
            width: $data.videoWidth ,
            height: $data.videoHeight 
          }, null, 8, _hoisted_36),
          _createElementVNode("canvas", {
            style: {"z-index":"2","background":"white","position":"absolute","left":"0","right":"0","margin":"auto"},
            ref: "dispCanvas",
            width: $data.videoWidth/2 ,
            height: $data.videoHeight/2 
          }, null, 8, _hoisted_37),
          _createElementVNode("canvas", {
            style: {"z-index":"3","position":"absolute","right":"0","left":"0","margin":"auto"},
            ref: "dispCircleCanvas",
            width: $data.videoWidth/2 ,
            height: $data.videoHeight/2 
          }, null, 8, _hoisted_38),
          _createElementVNode("canvas", {
            style: {"z-index":"4","position":"absolute","right":"0","left":"0","margin":"auto"},
            ref: "denshiShoKokubanCanvas",
            width: $data.videoWidth/2 ,
            height: $data.videoHeight/2 
          }, null, 8, _hoisted_39),
          _createElementVNode("canvas", {
            style: {"z-index":"5","position":"absolute","right":"0","left":"0","margin":"auto"},
            ref: "dispOverlayCircleCanvas",
            onMousedown: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => ($options.touchSetDetectingPoint && $options.touchSetDetectingPoint(...args))),
            onTouchstart: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => ($options.touchSetDetectingPoint && $options.touchSetDetectingPoint(...args))),
            width: $data.videoWidth/2.0 + 15,
            height: $data.videoHeight/2.0 + 15
          }, null, 40, _hoisted_40),
          _hoisted_41,
          _createElementVNode("div", {
            style: _normalizeStyle([{"min-width":"320px","min-height":"320px"}, { width: ($data.videoWidth/2) + 'px', height: ($data.videoHeight/2) + 'px' }]),
            id: "overlay"
          }, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($data.denshiShoKokuban.builder) = $event)),
              id: "input1",
              class: "inputField",
              type: "text"
            }, null, 512), [
              [_vModelText, $data.denshiShoKokuban.builder]
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($data.denshiShoKokuban.projectName) = $event)),
              id: "input2",
              class: "inputField",
              type: "text"
            }, null, 512), [
              [_vModelText, $data.denshiShoKokuban.projectName]
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($data.denshiShoKokuban.projectType) = $event)),
              id: "input3",
              class: "inputField",
              type: "text"
            }, null, 512), [
              [_vModelText, $data.denshiShoKokuban.projectType]
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($data.denshiShoKokuban.site) = $event)),
              id: "input4",
              class: "inputField",
              type: "text"
            }, null, 512), [
              [_vModelText, $data.denshiShoKokuban.site]
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($data.denshiShoKokuban.status) = $event)),
              id: "input5",
              class: "inputField",
              type: "text"
            }, null, 512), [
              [_vModelText, $data.denshiShoKokuban.status]
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("button", {
                class: "btn btn-dark",
                style: {"width":"40px"},
                onClick: _cache[16] || (_cache[16] = ($event: any) => ($options.moveCircle('left')))
              }, "◀"),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("button", {
                  class: "btn btn-dark",
                  style: {"width":"40px"},
                  onClick: _cache[17] || (_cache[17] = ($event: any) => ($options.moveCircle('up')))
                }, "▲"),
                _createElementVNode("button", {
                  class: "btn btn-dark",
                  style: {"width":"40px"},
                  onClick: _cache[18] || (_cache[18] = ($event: any) => ($options.moveCircle('down')))
                }, "▼")
              ]),
              _createElementVNode("button", {
                class: "btn btn-dark",
                style: {"width":"40px"},
                onClick: _cache[19] || (_cache[19] = ($event: any) => ($options.moveCircle('right')))
              }, "▶"),
              _hoisted_44,
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  style: {"width":"40px","color":"white"},
                  onClick: _cache[20] || (_cache[20] = ($event: any) => ($options.setOverlayRadius(3)))
                }, _hoisted_47),
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  style: {"width":"40px","font-size":"17px","color":"white"},
                  onClick: _cache[21] || (_cache[21] = ($event: any) => ($options.setOverlayRadius(-3)))
                }, _hoisted_49)
              ]),
              _hoisted_50,
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("button", {
                  class: "btn btn-dark",
                  style: {"width":"47px","color":"white"},
                  onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => ($options.undoCircle && $options.undoCircle(...args)))
                }, "↩"),
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  style: {"width":"47px"},
                  onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => ($options.getLaserDepth && $options.getLaserDepth(...args)))
                }, "🔍"),
                _createElementVNode("button", {
                  class: "btn btn-danger",
                  style: {"width":"47px","color":"white"},
                  onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => ($options.clearAllCircles && $options.clearAllCircles(...args)))
                }, _hoisted_53)
              ]),
              _hoisted_54,
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("button", {
                  class: "btn",
                  style: {"background":"none","border":"none","font-size":"20px"},
                  onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => ($options.switchToGreen && $options.switchToGreen(...args)))
                }, "🟢"),
                _createElementVNode("button", {
                  class: "btn btn-warning",
                  disabled: $data.isCaptureDisabled,
                  style: {"width":"47px"},
                  onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => ($options.captureTarget && $options.captureTarget(...args)))
                }, "📸", 8, _hoisted_56)
              ]),
              _hoisted_57,
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("button", {
                  class: "btn btn-success",
                  style: {"width":"40px","color":"white"},
                  onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => ($options.saveOverlapDataToExcel && $options.saveOverlapDataToExcel(...args)))
                }, "💾"),
                _createElementVNode("button", {
                  class: "btn btn-success",
                  style: {"width":"40px","font-size":"17px"},
                  onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => ($options.downloadLatestExcelFile && $options.downloadLatestExcelFile(...args)))
                }, "⬇️")
              ])
            ]),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (($data.selectedMainCameraDevice) = $event)),
              style: {"position":"absolute","bottom":"0px","z-index":"99","text-align":"center","left":"0","width":"18px"},
              onChange: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => ($options.changeMainCamera && $options.changeMainCamera(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.cameraDeviceIds, (option) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: option,
                  key: option
                }, _toDisplayString(option.label), 9, _hoisted_59))
              }), 128))
            ], 544), [
              [_vModelSelect, $data.selectedMainCameraDevice]
            ]),
            _hoisted_60,
            _withDirectives(_createElementVNode("div", _hoisted_61, [
              _hoisted_62,
              _createElementVNode("video", _hoisted_63, null, 512),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (($data.selectedSubCameraDevice) = $event)),
                style: {"position":"absolute","bottom":"0px","z-index":"99","width":"18px","text-align":"center","left":"0"},
                onChange: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => ($options.startSubCamera && $options.startSubCamera(...args)))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.cameraDeviceIds, (option) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: option,
                    key: option
                  }, _toDisplayString(option.label), 9, _hoisted_64))
                }), 128))
              ], 544), [
                [_vModelSelect, $data.selectedSubCameraDevice]
              ])
            ], 512), [
              [_vShow, $data.useSubCamera]
            ])
          ], 4),
          _createElementVNode("canvas", {
            style: {"display":"none !important","z-index":"3","position":"absolute","left":"0","right":"0","margin":"auto"},
            ref: "canvasOutput",
            width: $data.videoWidth ,
            height: $data.videoHeight
          }, null, 8, _hoisted_65)
        ])
      ]),
      _createElementVNode("div", _hoisted_66, " Touch detected! ", 512),
      _createElementVNode("div", _hoisted_67, [
        _createElementVNode("div", _hoisted_68, [
          _withDirectives(_createElementVNode("span", null, [
            _hoisted_69,
            _createTextVNode(" " + _toDisplayString(this.ceilDemicalPoint ( this.fullLength ,3 )) + " mm ", 1)
          ], 512), [
            [_vShow, $data.selectedDetectionMode.includes('length')]
          ]),
          _withDirectives(_createElementVNode("span", null, [
            _hoisted_70,
            _createTextVNode(" " + _toDisplayString(this.ceilDemicalPoint( this.diameter ,3 )) + " mm ", 1)
          ], 512), [
            [_vShow, $data.selectedDetectionMode.includes('circle')]
          ]),
          ($data.isGpsUsed)
            ? (_openBlock(), _createElementBlock("b", _hoisted_71, " 位置情報: "))
            : _createCommentVNode("", true),
          ($data.isGpsUsed)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                style: {"cursor":"pointer"},
                onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => ($options.gpsLink && $options.gpsLink(...args)))
              }, _toDisplayString($data.gps.lat) + "," + _toDisplayString($data.gps.lon), 1))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("span", null, [
            _hoisted_72,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (($data.scaleRealWorldDiameter) = $event)),
              type: "number",
              min: "4.0",
              max: "100.0",
              step: "0.2"
            }, null, 512), [
              [_vModelText, $data.scaleRealWorldDiameter]
            ]),
            _createTextVNode(" cm ")
          ], 512), [
            [_vShow, $data.selectedDetectionMode.includes('circle')]
          ])
        ]),
        _createElementVNode("div", _hoisted_73, [
          _createElementVNode("button", {
            class: _normalizeClass([$options.undoButtonClass, "btn btn-sm"]),
            onClick: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => ($options.undo && $options.undo(...args)))
          }, "UNDO", 2)
        ])
      ]),
      ($data.isDebugMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
            _hoisted_75,
            _createTextVNode(),
            _hoisted_76,
            _createElementVNode("div", _hoisted_77, [
              _hoisted_78,
              _createTextVNode(" " + _toDisplayString($data.testCircleDetectionSetting) + " ", 1),
              _hoisted_79,
              _createElementVNode("button", {
                class: "btn btn-dark",
                onClick: _cache[36] || (_cache[36] = ($event: any) => ($data.testSettingVisble=!$data.testSettingVisble))
              }, " テスト | 削孔検出 設定 "),
              ($data.testSettingVisble)
                ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                    _hoisted_81,
                    _createTextVNode(),
                    _hoisted_82,
                    _hoisted_83,
                    _createElementVNode("div", null, [
                      _createTextVNode(" dp "),
                      _createElementVNode("div", {
                        class: "square",
                        style: _normalizeStyle({ transform: 'rotate('+_ctx.rotate+'deg)' })
                      }, null, 4),
                      _withDirectives(_createElementVNode("input", {
                        type: "range",
                        min: "1",
                        max: "2",
                        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (($data.testCircleDetectionSetting.dp) = $event))
                      }, null, 512), [
                        [_vModelText, $data.testCircleDetectionSetting.dp]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createTextVNode(" minDist "),
                      _createElementVNode("div", {
                        class: "square",
                        style: _normalizeStyle({ transform: 'rotate('+_ctx.rotate+'deg)' })
                      }, null, 4),
                      _withDirectives(_createElementVNode("input", {
                        type: "range",
                        step: "0.1",
                        max: "254",
                        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (($data.testCircleDetectionSetting.minDist) = $event))
                      }, null, 512), [
                        [_vModelText, $data.testCircleDetectionSetting.minDist]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createTextVNode(" param1 "),
                      _createElementVNode("div", {
                        class: "square",
                        style: _normalizeStyle({ transform: 'rotate('+_ctx.rotate+'deg)' })
                      }, null, 4),
                      _withDirectives(_createElementVNode("input", {
                        type: "range",
                        max: "254",
                        "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (($data.testCircleDetectionSetting.param1) = $event))
                      }, null, 512), [
                        [_vModelText, $data.testCircleDetectionSetting.param1]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createTextVNode(" param2 "),
                      _createElementVNode("div", {
                        class: "square",
                        style: _normalizeStyle({ transform: 'rotate('+_ctx.rotate+'deg)' })
                      }, null, 4),
                      _withDirectives(_createElementVNode("input", {
                        type: "range",
                        max: "254",
                        "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (($data.testCircleDetectionSetting.param2) = $event))
                      }, null, 512), [
                        [_vModelText, $data.testCircleDetectionSetting.param2]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createTextVNode(" maxRadius "),
                      _createElementVNode("div", {
                        class: "square",
                        style: _normalizeStyle({ transform: 'rotate('+_ctx.rotate+'deg)' })
                      }, null, 4),
                      _withDirectives(_createElementVNode("input", {
                        type: "range",
                        max: "254",
                        "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (($data.testCircleDetectionSetting.maxRadius) = $event))
                      }, null, 512), [
                        [_vModelText, $data.testCircleDetectionSetting.maxRadius]
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createTextVNode(" minRadius "),
                      _createElementVNode("div", {
                        class: "square",
                        style: _normalizeStyle({ transform: 'rotate('+_ctx.rotate+'deg)' })
                      }, null, 4),
                      _withDirectives(_createElementVNode("input", {
                        type: "range",
                        max: "254",
                        "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => (($data.testCircleDetectionSetting.minRadius) = $event))
                      }, null, 512), [
                        [_vModelText, $data.testCircleDetectionSetting.minRadius]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_84, [
              _createElementVNode("span", null, " 半径 ピクセル数 : " + _toDisplayString($data.currentCircle.radius), 1),
              _hoisted_85,
              _createElementVNode("span", null, "avgLength : " + _toDisplayString($data.avgLength) + " fullLength : " + _toDisplayString($data.fullLength) + " diameter " + _toDisplayString($data.diameter) + " nonOverlapCircleArea " + _toDisplayString($data.nonOverlapCircleArea), 1),
              _hoisted_86,
              _createElementVNode("span", null, " serial1 : " + _toDisplayString($data.serial1Value) + " serial2 : " + _toDisplayString($data.serial2Value) + " serial3 : " + _toDisplayString($data.serial3Value), 1),
              _hoisted_87,
              _hoisted_88,
              _hoisted_89,
              _createElementVNode("span", null, " serial1 : " + _toDisplayString($data.serial1Error) + " serial2 : " + _toDisplayString($data.serial2Error) + " serial3 : " + _toDisplayString($data.serial3Error), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_90, [
        _createElementVNode("button", {
          class: _normalizeClass(["col-2 btn", $data.isMeasuring ? 'btn-warning' : 'btn-dark' ]),
          style: {"z-index":"4","position":"fixed","height":"300px","width":"300px","border-radius":"100%","left":"0","bottom":"4%"},
          onClick: _cache[43] || (_cache[43] = ($event: any) => ($options.startMeasurement()))
        }, _toDisplayString($data.isMeasuring ?  "計測終了": "計測開始"), 3),
        _createElementVNode("button", {
          class: _normalizeClass([$data.isMeasuring ? 'btn-dark':'btn-secondary' , "offset-1 col-2 btn"]),
          style: {"z-index":"4","height":"300px","width":"300px","border-radius":"100%","right":"0","position":"fixed","bottom":"50%"},
          onClick: _cache[44] || (_cache[44] = ($event: any) => ($options.stop({'diameter':true})))
        }, "削孔径、削孔長を入力", 2),
        _createElementVNode("button", {
          class: _normalizeClass([$data.isMeasuring ? 'btn-dark':'btn-secondary' , "offset-1 col-2 btn"]),
          style: {"z-index":"4","height":"300px","width":"300px","border-radius":"100%","right":"0","position":"fixed","bottom":"0%"},
          onClick: _cache[45] || (_cache[45] = ($event: any) => ($options.stop({'diameter':false})))
        }, "削孔長を入力", 2)
      ])
    ], 512), [
      [_vShow, $data.viewState.isCanvasShow]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_91, [
        _createElementVNode("a", {
          class: "col-3 show-excel",
          onClick: _cache[46] || (_cache[46] = ($event: any) => ($options.showExcelMenu('File'))),
          style: {"cursor":"pointer"}
        }, [
          _createVNode(_component_font_awesome_icon, {
            icon: $data.faFile,
            size: "lg"
          }, null, 8, ["icon"]),
          _createTextVNode(" 設定 ")
        ]),
        _createElementVNode("a", _hoisted_92, " 削孔長の入力開始セル : " + _toDisplayString(( $data.selectedFullLengthCell.row !==-1 ||  $data.selectedFullLengthCell.col !==-1) ? ($data.selectedFullLengthCell.row+1 ) +"-"+ $options.exchangeToColName( $data.selectedFullLengthCell.col +1  ) : "未選択"), 1),
        _createElementVNode("a", _hoisted_93, " 削孔径の入力開始セル : " + _toDisplayString(( $data.selectedDiameterCell.row !==-1 ||  $data.selectedDiameterCell.col !==-1) ? ($data.selectedDiameterCell.row+1) +"-"+ $options.exchangeToColName( $data.selectedDiameterCell.col +1 ) : "未選択"), 1),
        _createElementVNode("button", {
          class: "z-index:999; col-2 btn btn-dark",
          style: {"position":"fixed","height":"300px","width":"300px","border-radius":"100%","right":"0","bottom":"10%"},
          onClick: _cache[47] || (_cache[47] = ($event: any) => ($options.showArea('Canvas')))
        }, "計測へ戻る"),
        ($data.viewState.isExcelFileMenuShow)
          ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
              _hoisted_95,
              _createElementVNode("a", {
                class: "show-excel",
                style: {"cursor":"pointer"},
                onClick: _cache[48] || (_cache[48] = 
//@ts-ignore
(...args) => ($options.selectCellMode && $options.selectCellMode(...args)))
              }, "入力開始セルの位置の選択"),
              _hoisted_96,
              _createElementVNode("a", {
                class: "show-excel",
                style: {"cursor":"pointer"},
                onClick: _cache[49] || (_cache[49] = 
//@ts-ignore
(...args) => ($options.saveXlsx && $options.saveXlsx(...args)))
              }, "エクセルファイルの保存"),
              _hoisted_97,
              _createElementVNode("a", {
                class: "show-excel",
                style: {"cursor":"pointer"},
                onClick: _cache[50] || (_cache[50] = 
//@ts-ignore
(...args) => ($options.exportXlsx && $options.exportXlsx(...args)))
              }, "エクセルファイルのエクスポート"),
              _hoisted_98,
              _createElementVNode("div", _hoisted_99, [
                _hoisted_100,
                _createElementVNode("input", {
                  onChange: _cache[51] || (_cache[51] = 
//@ts-ignore
(...args) => ($options.importXlsx && $options.importXlsx(...args))),
                  type: "file",
                  id: "inputGroupFile01",
                  class: "show-excel form-control",
                  "aria-describedby": "inputGroupFileAddon01"
                }, null, 32)
              ]),
              _hoisted_101
            ]))
          : _createCommentVNode("", true),
        _hoisted_102
      ]),
      _hoisted_103,
      _createTextVNode(),
      _hoisted_104,
      _createElementVNode("h2", null, _toDisplayString(this.filename), 1),
      _hoisted_105,
      _hoisted_106
    ], 512), [
      [_vShow, $data.viewState.isExcelShow]
    ]),
    ($data.viewState.isSettingShow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
          _createElementVNode("h4", {
            class: "h4",
            onClick: _cache[52] || (_cache[52] = 
//@ts-ignore
(...args) => ($options.onDebugMode && $options.onDebugMode(...args)))
          }, "補正ファイルのアップロード"),
          _createElementVNode("input", {
            type: "file",
            onChange: _cache[53] || (_cache[53] = 
//@ts-ignore
(...args) => ($options.readCorrectionFile && $options.readCorrectionFile(...args)))
          }, null, 32),
          _createElementVNode("h4", {
            class: "h4",
            onClick: _cache[54] || (_cache[54] = 
//@ts-ignore
(...args) => ($options.onDebugMode && $options.onDebugMode(...args)))
          }, "レーザ距離センサの接続設定"),
          _hoisted_108,
          _createVNode(_component_SerialConnection, {
            ref: "measurementSerial",
            serial: $data.serial1
          }, null, 8, ["serial"]),
          _hoisted_109,
          _createVNode(_component_SerialConnection, {
            ref: "assistanceSerial1",
            serial: $data.serial2
          }, null, 8, ["serial"]),
          _hoisted_110,
          _createVNode(_component_SerialConnection, {
            ref: "assistanceSerial2",
            serial: $data.serial3
          }, null, 8, ["serial"]),
          _hoisted_111,
          _createElementVNode("button", {
            onClick: _cache[55] || (_cache[55] = 
//@ts-ignore
(...args) => ($options.calibrationStart && $options.calibrationStart(...args))),
            class: "btn btn-dark"
          }, " キャリブレーション開始 "),
          _hoisted_112,
          _hoisted_113,
          _createElementVNode("button", {
            onClick: _cache[56] || (_cache[56] = 
//@ts-ignore
(...args) => ($options.clearCalibration && $options.clearCalibration(...args))),
            class: "btn btn-dark"
          }, " キャリブレーションのクリア "),
          _hoisted_114,
          _withDirectives(_createElementVNode("div", null, [
            _hoisted_115,
            _hoisted_116,
            _hoisted_117,
            _createTextVNode(" 理想値"),
            _hoisted_118,
            _withDirectives(_createElementVNode("input", {
              step: "1",
              type: "number",
              "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => (($data.cameraRate.ideal) = $event))
            }, null, 512), [
              [_vModelText, $data.cameraRate.ideal]
            ]),
            _hoisted_119,
            _createTextVNode(" 最大値"),
            _hoisted_120,
            _withDirectives(_createElementVNode("input", {
              step: "1",
              type: "number",
              "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => (($data.cameraRate.max) = $event))
            }, null, 512), [
              [_vModelText, $data.cameraRate.max]
            ]),
            _hoisted_121,
            _hoisted_122,
            _createTextVNode(),
            _hoisted_123,
            _withDirectives(_createElementVNode("input", {
              step: "0",
              type: "number",
              "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => (($data.detectCircleIntervalMs) = $event))
            }, null, 512), [
              [_vModelText, $data.detectCircleIntervalMs]
            ]),
            _hoisted_124,
            _hoisted_125,
            _createTextVNode(),
            _hoisted_126,
            _withDirectives(_createElementVNode("input", {
              step: "0",
              type: "number",
              "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => (($data.measurementTimerMs) = $event))
            }, null, 512), [
              [_vModelText, $data.measurementTimerMs]
            ]),
            _hoisted_127,
            _hoisted_128,
            _hoisted_129,
            _hoisted_130,
            _createTextVNode(" [(実測値)ーA]÷B "),
            _hoisted_131,
            _createTextVNode(" A "),
            _withDirectives(_createElementVNode("input", {
              step: "0.000000001",
              type: "number",
              "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => (($data.calibrationA) = $event))
            }, null, 512), [
              [_vModelText, $data.calibrationA]
            ]),
            _createTextVNode(),
            _hoisted_132,
            _createTextVNode(" B "),
            _withDirectives(_createElementVNode("input", {
              step: "0.000000001",
              type: "number",
              "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => (($data.calibrationB) = $event))
            }, null, 512), [
              [_vModelText, $data.calibrationB]
            ]),
            _hoisted_133,
            _hoisted_134,
            _hoisted_135,
            _hoisted_136,
            _withDirectives(_createElementVNode("input", {
              step: "0.001",
              type: "number",
              "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => (($data.calibrationLongLengthMeter) = $event))
            }, null, 512), [
              [_vModelText, $data.calibrationLongLengthMeter]
            ]),
            _hoisted_137,
            _hoisted_138,
            _createTextVNode(),
            _hoisted_139,
            _withDirectives(_createElementVNode("input", {
              step: "0.001",
              type: "number",
              "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => (($data.calibrationShortLengthMeter) = $event))
            }, null, 512), [
              [_vModelText, $data.calibrationShortLengthMeter]
            ]),
            _createTextVNode(),
            _hoisted_140,
            _hoisted_141,
            _createTextVNode(),
            _hoisted_142,
            _withDirectives(_createElementVNode("input", {
              step: "1",
              type: "number",
              "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => (($data.DiameterCorrectionValue.detectStartPoint) = $event))
            }, null, 512), [
              [_vModelText, $data.DiameterCorrectionValue.detectStartPoint]
            ]),
            _hoisted_143,
            _hoisted_144,
            _createTextVNode(),
            _hoisted_145,
            _createTextVNode(" もっとも長いレーザーの値が"),
            _withDirectives(_createElementVNode("input", {
              step: "0.001",
              type: "number",
              "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => (($data.calibrationThresholdShortMeasurementsCentimeter) = $event))
            }, null, 512), [
              [_vModelText, $data.calibrationThresholdShortMeasurementsCentimeter]
            ]),
            _createTextVNode(" cm以下の場合 "),
            _hoisted_146,
            _createTextVNode(" 出力値（削孔長）＝＜最も長いレーザーの値＞ー＜2つの短いレーザーの値の平均＞ - "),
            _withDirectives(_createElementVNode("input", {
              step: "0.001",
              type: "number",
              "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => (($data.calibrationCorrectionShortMeasurementsMillimetre) = $event))
            }, null, 512), [
              [_vModelText, $data.calibrationCorrectionShortMeasurementsMillimetre]
            ]),
            _createTextVNode(),
            _hoisted_147,
            _createElementVNode("button", {
              style: {"margin":"10px"},
              onClick: _cache[68] || (_cache[68] = 
//@ts-ignore
(...args) => ($options.makeCorrectionFile && $options.makeCorrectionFile(...args))),
              class: "btn btn-dark"
            }, " 補正ファイルを生成する ")
          ], 512), [
            [_vShow, $data.isDebugMode]
          ]),
          _hoisted_148,
          _createElementVNode("div", null, [
            _hoisted_149,
            _createElementVNode("span", null, " serial1 : " + _toDisplayString($data.serial1Value) + " m ", 1),
            _createTextVNode(),
            _hoisted_150,
            _createElementVNode("span", null, " serial2 : " + _toDisplayString($data.serial2Value) + " m ", 1),
            _hoisted_151,
            _createElementVNode("span", null, " serial3 : " + _toDisplayString($data.serial3Value) + " m ", 1),
            _hoisted_152
          ]),
          ($data.isDebugMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_153, [
                _hoisted_154,
                _createElementVNode("span", null, " + " + _toDisplayString($data.calibration.serial1Value) + " m ", 1),
                _createTextVNode(),
                _hoisted_155,
                _createElementVNode("span", null, " + " + _toDisplayString($data.calibration.serial2Value) + " m ", 1),
                _createTextVNode(),
                _hoisted_156,
                _createElementVNode("span", null, " + " + _toDisplayString($data.calibration.serial3Value) + " m ", 1),
                _createTextVNode(),
                _hoisted_157
              ]))
            : _createCommentVNode("", true),
          ($data.isDebugMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_158, [
                _hoisted_159,
                _createElementVNode("span", null, " serial1 : " + _toDisplayString($options.addValue( $data.serial1Value, $data.calibrationLongLengthMeter  , $data.calibrationShortLengthMeter)) + " m", 1),
                _createTextVNode(),
                _hoisted_160,
                _createElementVNode("span", null, " serial2 : " + _toDisplayString($options.addValue( $data.serial2Value, $data.calibrationLongLengthMeter  , $data.calibrationShortLengthMeter)) + " m ", 1),
                _hoisted_161,
                _createElementVNode("span", null, " serial3 : " + _toDisplayString($options.addValue($data.serial3Value, $data.calibrationLongLengthMeter  , $data.calibrationShortLengthMeter)) + " m ", 1),
                _hoisted_162
              ]))
            : _createCommentVNode("", true),
          _hoisted_163,
          _hoisted_164,
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            id: "checkbox",
            "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => (($data.calibration.isLowerThanBothLengthChecked) = $event))
          }, null, 512), [
            [_vModelCheckbox, $data.calibration.isLowerThanBothLengthChecked]
          ]),
          _hoisted_165,
          _createElementVNode("button", {
            style: {"margin":"10px"},
            onClick: _cache[70] || (_cache[70] = 
//@ts-ignore
(...args) => ($options.calibrationAdd && $options.calibrationAdd(...args))),
            class: "btn btn-dark"
          }, " 設定する "),
          _hoisted_166
        ]))
      : _createCommentVNode("", true)
  ]))
}